import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AddRole, HttpResponse, RoleDetail } from "../interfaces";
import { UserHttpService } from "./user-session.service";

@Injectable({
  providedIn: "root",
})
export class ManageRoleService {
  constructor(private userService: UserHttpService, private http: HttpClient) {}

  addRole(body: AddRole, isEdit: boolean = false, id?: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userService.userToken);
    formData.append("role_name", body.role_name);
    formData.append("description", body.description);
    formData.append("permission", JSON.stringify(body.permission));

    if(isEdit) {
      formData.append("role_id", id ? id : '');
    };
    return this.http.post<HttpResponse<any>>("roles/createRole", formData);
  }

  rolesList(): Observable<HttpResponse<RoleDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userService.userToken);
    return this.http.post<HttpResponse<RoleDetail[]>>(
      "roles/roleList",
      formData
    );
  }

  getRoleDetail(id: string): Observable<HttpResponse<RoleDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userService.userToken);
    formData.append("role_id", id);
    return this.http.post<HttpResponse<any>>("roles/roleDetail", formData);
  }

  deleteRole(id: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userService.userToken);
    formData.append("role_id", id);
    return this.http.post<HttpResponse<any>>("roles/roleDelete", formData);
  }
}
